import urlParse from 'url-parse';

export function getWorkspaceNameFromUrl(): string {
  const urlParams = urlParse(window.location.search, true);
  return urlParams.query['workspace'] || '';
}
